export default __webpack_public_path__ + "static/media/paranas_banner.9eb21661.png";